import {useMutation} from '@apollo/react-hooks';

import type {
    DeleteActivityType as DeleteActivityTypeMutation,
    DeleteActivityTypeVariables as DeleteActivityTypeMutationVariables,
    ActivityTypeDeleteInput,
} from 'nutshell-graphql-types';

import GET_ACTIVITY_TYPES from '../../../../core/select/queries/get-activity-types.graphql';

import DELETE_ACTIVITY_TYPE from '../mutations/delete-activity-type.graphql';

export function useDeleteActivityType(): {
    deleteActivityType: (arg1: ActivityTypeDeleteInput) => Promise<any>;
    isDeleting: boolean;
} {
    const [deleteActivityType, {loading}] = useMutation<
        DeleteActivityTypeMutation,
        DeleteActivityTypeMutationVariables
    >(DELETE_ACTIVITY_TYPE, {
        refetchQueries: [{query: GET_ACTIVITY_TYPES}],
    });

    return {
        deleteActivityType: (input: ActivityTypeDeleteInput) =>
            deleteActivityType({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const deletedActivityType =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.activityTypeDelete &&
                        mutationResults.data.activityTypeDelete.activityType;

                    const cacheResult = proxy.readQuery({
                        query: GET_ACTIVITY_TYPES,
                    });

                    if (cacheResult && deletedActivityType) {
                        proxy.writeQuery({
                            query: GET_ACTIVITY_TYPES,
                            data: {
                                // @ts-expect-error
                                activityTypes: cacheResult.activityTypes.filter(
                                    // @ts-expect-error
                                    (activityType) => activityType.id !== deletedActivityType.id
                                ),
                            },
                        });
                    }
                },
            }),
        isDeleting: loading,
    };
}
